import { useCallback, useEffect, useRef, useState } from 'react';

import { fetch_close_switch } from '../api';

/*
 * PROD-7828 — the month-close switch as the shell holds it: read on mount, re-read on demand (a Needs
 * attention reload, a stale toggle), replaced by a toggle's answer. A failed read keeps what was shown
 * (null at first, which hides the chip): the chip is decoration and never toasts or blocks the page.
 */
const useCloseSwitch = () => {
  const [data, setData] = useState(null);
  // Only the newest read lands, so a slow read never overwrites a toggle's answer.
  const seq = useRef(0);

  const reload = useCallback(() => {
    seq.current += 1;
    const mine = seq.current;
    fetch_close_switch()
      .then((d) => {
        if (mine === seq.current) setData(d);
      })
      .catch(() => {});
  }, []);

  const replace = useCallback((d) => {
    seq.current += 1;
    setData(d);
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, reload, replace };
};

export default useCloseSwitch;
